import React from 'react';
import './button.scss';
export var Loader = function (_a) {
    var size = _a.size;
    return (React.createElement("span", { className: "c-btn--loading-button", style: { width: size, height: size } }));
};
